export const SERVICE_CODE = 'OFFICE_SERVICE';